import * as React from "react";
const SvgLightbulb01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.965 17.535h-3.93V19c0 .48 0 .788.017 1.023.015.226.041.31.056.346a.97.97 0 0 0 .523.523c.037.015.12.04.346.056.235.016.543.017 1.023.017s.788 0 1.023-.017c.226-.015.31-.041.346-.056a.97.97 0 0 0 .523-.523c.015-.037.04-.12.056-.346.016-.235.017-.543.017-1.023zm4.5-8.035a6.465 6.465 0 1 0-12.93 0c0 2.594 1.523 4.926 3.69 5.965h5.55c2.167-1.039 3.69-3.37 3.69-5.965m2.07 0c0 3.239-1.809 6.182-4.5 7.644V19c0 .452 0 .843-.021 1.165a3.1 3.1 0 0 1-.21.996 3.04 3.04 0 0 1-1.643 1.643c-.33.137-.665.187-.996.21-.322.022-.713.021-1.165.021s-.843 0-1.165-.021a3.1 3.1 0 0 1-.996-.21 3.04 3.04 0 0 1-1.643-1.643 3.1 3.1 0 0 1-.21-.996c-.022-.322-.021-.713-.021-1.165v-1.856c-2.691-1.462-4.5-4.405-4.5-7.644a8.535 8.535 0 0 1 17.07 0"
}));
export default SvgLightbulb01;
//# sourceMappingURL=Lightbulb01.js.map